import { CartItem } from "modules/cart/types/cart";
import { getPriceEndpoint } from "../../main/services/endpoints";
import type { FetchDataOptions } from "modules/main/services/fetchData";
import { AddCartMethod } from "../types/add-cart-methods";
import { AuthError } from "modules/authentication/types/form-login-types";
import { getVisitorId } from "utils/analytics";

export const getPrice = async (sku: string, qty: number, method: AddCartMethod): Promise<CartItem> => {
    const defaultOptions: FetchDataOptions = {
        method: "GET",
        headers: { "x-visitor-id": getVisitorId() },
        credentials: "include",
    };
    const response = await fetch(getPriceEndpoint(sku, qty, method), {
        method: defaultOptions.method,
        headers: defaultOptions.headers,
        credentials: defaultOptions.credentials,
    });
    if (!response.ok) {
        if (response.status === 401) throw new AuthError("Unauthorized");
        throw new Error(`Error: ${response.statusText}`);
    }
    return response.json();
}